import { styled } from 'styled-components';

export const Container = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem;
  border: 1px solid ${({ theme }) => theme.colors.warning.color};
  border-radius: 10px;
  margin-bottom: 1rem;

  p {
    color: ${({ theme }) => theme.colors.warning.color};
    flex: 1;
  }

  svg {
    width: 0.6rem;
    color: ${({ theme }) => theme.colors.warning.color};
  }
`;
